import type { Mission } from '../missions.ts'

export const rma: Mission = {
  id: "rma",
  name: "Risk Management Agency",
  short: "RMA",
  call: "Crops",
  kind: "subagency",
  parent: "usda",
  url: "https://www.rma.usda.gov/",
  established: 1996,
  palette: {
    primary: "#30417e",
    secondary: "#174e3c",
    accent: "#b6e159",
  },
  colorSource: {
    kind: "site",
    url: "https://www.rma.usda.gov/",
  },
  motif: "shield",
  mission: {
    text: "Serving America’s agricultural producers through effective, market-based risk management tools to strengthen the economic stability of agricultural producers and rural communities.",
    url: "https://www.rma.usda.gov/about-rma/what-we-do/mission-values",
  },
  fact: {
    text: "RMA was created in 1996 to administer the programs of the Federal Crop Insurance Corporation, which Congress created in 1938.",
    url: "https://www.rma.usda.gov/about-rma/history-rma",
  },
  logo: {
    file: "public/logos/rma.svg",
    source: "https://commons.wikimedia.org/wiki/File:US-RiskManagementAgency-Logo.svg",
  },
  identifier: {
    about: "https://www.rma.usda.gov/about-rma",
    accessibility: "https://www.rma.usda.gov/about-rma/website-policies-important-links/accessibility-statement",
    foia: "https://www.rma.usda.gov/about-rma/website-policies-important-links/foia",
    noFear: "https://www.rma.usda.gov/about-rma/website-policies-important-links/no-fear-act",
    oig: "https://www.oig.usda.gov/",
    privacy: "https://www.rma.usda.gov/about-rma/website-policies-important-links/privacy-policy",
  },
  media: {
    photos: [
      {
        file: "/media/rma-drought-corn.jpg",
        small: "/media/rma-drought-corn-sm.jpg",
        alt: "Withered, brown corn stalks stand in rows of cracked, dry soil under a blue sky with white clouds.",
        title: "Corn damaged by drought in Texas, August 20, 2013",
        creator: "Bob Nichols, U.S. Department of Agriculture",
        source: "https://commons.wikimedia.org/wiki/File:Corn_shows_the_effect_of_drought.jpg",
        license: "Public domain (U.S. government work)",
      },
      {
        file: "/media/rma-flooded-field.jpg",
        small: "/media/rma-flooded-field-sm.jpg",
        alt: "A green tractor and planter stand stranded in a farm field covered by floodwater, with a tree line on the far shore.",
        title: "Flooded farm field in the Park and Tongue River watershed, North Dakota, May 23, 2013",
        creator: "Keith Weston, U.S. Department of Agriculture",
        source: "https://commons.wikimedia.org/wiki/File:ClimateVisuals-flickr-8947302196_Watterlogged_field_with_tractor_%C2%A9_USDA_Public_Domain.jpg",
        license: "CC BY 2.0",
      },
    ],
  },
}
